import { render, staticRenderFns } from "./BTableWithAutocompleteAsync.vue?vue&type=template&id=0f66d147&"
import script from "./BTableWithAutocompleteAsync.vue?vue&type=script&lang=js&"
export * from "./BTableWithAutocompleteAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports